
















import { Vue, Component, Prop } from "@/shared/vuepack";
import PartnerMonthlyEmployerReport from "./PartnerMonthlyEmployerReport.vue";
import { useBillingStore } from "@/shared/store/billing";

@Component({
  components: {
    PartnerMonthlyEmployerReport
  }
})

export default class PartnerReconReport extends Vue {
  billingStore = useBillingStore();

  @Prop() partnerId: number;

  get selectableBillingPeriods () { return this.billingStore.getSelectableReconBillingPeriods; }
  get employers () { return this.billingStore.getReconEmployers; }
  get periodsLoaded () { return this.billingStore.getReconBillingPeriodsLoaded; }
  get loadBillingPeriodsByPartner () { return this.billingStore.loadReconBillingPeriodsByPartner; }
  get resetBillingPeriodsState () { return this.billingStore.resetReconBilling; }
  get downloadReportForPartner () { return this.billingStore.downloadReconReportForPartner; }
  get setPeriod () { return this.billingStore.setReconPeriod; }
  get setEmployer () { return this.billingStore.setReconPeriod; }
}


